import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
} from "../../../../../Utilitie";
import ComparativeTable from "./ComparativeTable";
import Loading from "../../../../../Extra/Loading";
const ComparativeReportMaster = ({}) => {
  const urlPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [fetchedData, setFetchData] = useState({
    loading: false,
    data: null,
    error: null,
  });
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const fetchData = async () => {
    setFetchData({ loading: true, data: null, error: null });
    try {
      const response = await axios.get(
        `${urlPrefix}getblockdataDateRangeMachineWise?start=${startDate}&end=${endDate}`,
      );
      setFetchData({ loading: false, data: response.data.data, error: null });
    } catch (err) {
      setFetchData({ loading: false, data: null, error: err });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="mt-1">
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv position-relative">
        <h5 className=""> Comparative Report</h5>
        <div className="row">
          <div className="col-md ">
            <b>From </b>
            <input
              type="date"
              max={endDate}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />
          </div>
          <div className="d-flex col-md">
            <b>To </b>
            <input
              type="date"
              value={endDate}
              max={getCurrentDate()}
              onChange={(e) => setEndDate(e.target.value)}
              // className="form-control"
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={() => {
                fetchData();
              }}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      {fetchedData.loading && <Loading />}
      {fetchedData?.data && (
        <div>
          <ComparativeTable
            data={fetchedData.data}
            date={{ startDate, endDate }}
          />
        </div>
      )}
    </div>
  );
};
export default ComparativeReportMaster;
